export const enMessages = {
  "errorOccurred": "An error occurred. Update the page.",
  "archiveFragmentUnavailable": "On this cell, the requested fragment of the archive is not available",
  "analyticsZonesHints": "Hints for editing analytics zones",
  "addPointToZone": "To add a point for the zone, click on the video.",
  "removePointFromZone": "To remove the point from the current zone, click on the point.",
  "removeAllPointsFromZone": "To remove all points from the current zone, click on the \"Clean\" button.",
  "movePoint": "Click the mouse button at the point and move it to change its position.",
  "editZonesIndividually": "You can not edit all zones at the same time, only separately.",
  "selectZoneToEdit": "Select a zone from the drop-down list to edit it. Keep in mind that the colors of the zones are not preserved.",
  "maxPointsInZone": "The maximum of one zone can be 100 points.",
  "acceleratedVideo": "Accelerated video",
  "analyticsZone": "Analytics zone",
  "availableZones": "Available zones",
  "showAll": "Show everything",
  "sensitivity": "Sensitivity",
  "deleteAllPointsInZone": "Delete all points in the current zone",
  "refreshPage": "Update the page",
  "from": "From",
  "to": "To",
  "download": "Download",
  "cancel": "Cancel",
  "clean": "Clean",
  "saveAllZones": "Save all zones",
  "save": "Save",
  "showHelp": "Show a certificate",
  "zoomOutArchiveScale": "Rigate the scope of the archive",
  "zoomInArchiveScale": "Close the scale of the archive",
  "goToCurrentMoment": "Go to the current moment",
  "archiveCalendar": "Archive calendar",
  "goToLiveStream": "Go to direct broadcast",
  "rewindBack15s": "Rewind for 15 seconds",
  "launch": "Launch",
  "pause": "Pause",
  "fastForward15s": "Squeeze forward for 15 seconds",
  "ptzControl": "PTZ Management",
  "takeScreenshot": "Take a screenshot",
  "videoAnalysisZones": "Video analysis zones",
  "playbackSpeed": "Reproduction speed",
  "downloadArchive": "Download Archive",
  "volume": "Volume",
  "settings": "Settings",
  "streams": "Streams",
  "noDelayStream": "No-delay",
  "fullscreen": "Turn out",
  "close": "Close",
  "confirm": "Confirm",
  "alertMessage": "Please contact the administrator.",
  "alertDialogTitle": "Message",
  "confirmDialogTitle": "Confirm action",
  "promptDialogTitle": "Attention",
  "deleteRow": "Delete row",
  "addRow": "Add row",
  "addRowTitle": "Add row",
  "selectFromList": "Select from the list",
}
